import { render, staticRenderFns } from "./PropertyGallery.vue?vue&type=template&id=c0fc756e"
import script from "./PropertyGallery.vue?vue&type=script&lang=js"
export * from "./PropertyGallery.vue?vue&type=script&lang=js"
import style0 from "./PropertyGallery.vue?vue&type=style&index=0&id=c0fc756e&prod&lang=postcss"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports